import MediaQuery from 'react-responsive';
import { hourFormat, shortDateFormat } from '@paradigm/utils/src/date';

import ColoredStrategyDescription from '#/components/UnifiedRfqs/components/strategy-description/ColoredStrategyDescription';
import { useDrfqOrders } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { Drfq } from '@paradigm/features/src/unified-rfqs/entities/drfq/domain';
import { isOrderExecuted } from '@paradigm/features/src/unified-rfqs/entities/drfq/orders';
import {
  Container,
  DateInfo,
  DrfqDetailsContent,
  getSideText,
  TradeInfoGrid,
  Label,
  TagSpan,
} from '#/components/UnifiedRfqs/components/DetailsModal';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { usePriceFormatterFn } from '@paradigm/features/src/unified-rfqs/ui/hooks/useFormattedPrice';

function RfqDescription({
  drfq,
  isExecuted,
}: {
  drfq: Drfq;
  isExecuted: boolean;
}) {
  return isExecuted ? (
    <DrfqDetailsTradeRecapContent drfq={drfq} />
  ) : (
    <DrfqDetailsContent drfq={drfq} isShowingMarkPrice />
  );
}

function DrfqDetailsTradeRecapContent({ drfq }: { drfq: Drfq }) {
  const orders = useDrfqOrders(drfq.id);
  const executedOrder = orders.find(isOrderExecuted);
  const productCode = drfq.product_codes[0];
  const priceFormatter = usePriceFormatterFn({
    side: executedOrder?.side,
    rfqType: 'drfq',
    description: drfq.description,
    productCode,
  });

  return (
    <Container>
      <TradeInfoGrid>
        {getSideText(executedOrder?.side ?? null)}

        <MediaQuery minWidth={MOBILE_BREAKPOINT}>
          <TagSpan>
            <ColoredStrategyDescription>
              {drfq.description}
            </ColoredStrategyDescription>
          </TagSpan>
        </MediaQuery>
        <Label>at</Label>
        <div css="text-align: left;">
          <TagSpan>
            {executedOrder == null ? '-' : priceFormatter(executedOrder.price)}
          </TagSpan>
          <span>{drfq.quote_currency}</span>
        </div>
      </TradeInfoGrid>

      <MediaQuery minWidth={MOBILE_BREAKPOINT}>
        <DateInfo>
          <p>{hourFormat(drfq.last_updated_at)}</p>
          <p>{shortDateFormat(drfq.last_updated_at)}</p>
        </DateInfo>
      </MediaQuery>
    </Container>
  );
}

export default RfqDescription;
